import React, { useState } from "react";
import "./InnovationCard.css";
import ApplyModal from "../InnovationMain/ApplyModal/ApplyModal";
const InnovationCard = ({ Info }) => {
  const [show, setShow] = useState(false);
  const [hoverLogo, setHoverLogo] = useState(false);
  const randomName = Info?.title1[0]?.text.replace(/ /g,'');

  const InnoContainer = `
   .${randomName}:hover {
      background: ${Info?.bg_color[0]?.text}!important;
      border: 1.5px solid ${Info?.color[0]?.text};
    }
  `;
  const finalClassName = `innovation-card ${randomName} hovereff w-100`;

  return (
    <>
    <style>
    {InnoContainer}
    </style>
      <div
        onClick={() => setShow(true)}
        onMouseEnter={() => setHoverLogo(true)}
        onMouseLeave={() => setHoverLogo(false)}
        className="d-flex justify-content-end  col-md-12  col-6">
        <div className={finalClassName} >
          <div className="innovation-media">
            <img
              src={!hoverLogo ? Info?.icon?.url : Info?.hover_icon?.url}
              alt=""
            />
          </div>
          <div className=" d-flex flex-column innovation-body">
            <p className="primary-text primary-fnt  m-0  fw-bold">
              {Info?.title1[0]?.text}{" "}
            </p>
            <p className="primary-fnt  primary-text m-0">
              {" "}
              {Info?.description1[0]?.text}{" "}
            </p>
          </div>
        </div>
        <div></div>
      </div>
      <ApplyModal show={show} setShow={setShow} Info={Info}></ApplyModal>
    </>
  );
};

export default InnovationCard;
